import notification from "antd/es/notification";
import { MessageDescriptor } from "react-intl";

import i18nService from "@app/config/I18nService";

// A warning toast about a deal action that was held back
const notifyDealWarning = (message: MessageDescriptor) =>
  notification.warn({
    message: i18nService.formatMessage(message, message.defaultMessage as string),
  });

export default notifyDealWarning;
